import { ArrowRight, Check, Stethoscope } from 'lucide-react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const TeacherDashboardDiagnosticWidgetEmpty = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-p-8">
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-6">
        <span className="tw-flex tw-p-4 tw-bg-stone-50 tw-rounded-full !tw-rotate-34">
          <Stethoscope size={30} className="tw-rotate-[345deg] tw-text-stone-500 " />
        </span>
        <p className="tw-text-gray-600 tw-text-2xl tw-font-atkinson tw-font-bold tw-mb-2">
          Nothing here yet, and <span className="tw-italic">that&apos;s okay</span>
        </p>
        <p className="tw-text-gray-500 tw-text-sm tw-font-atkinson">
          Results will show up here as students get started
        </p>
        <span className="tw-flex tw-flex-row tw-items-center tw-gap-x-2 tw-rounded-3xl tw-bg-emerald-50 tw-px-4 tw-py-2">
          <Check className="tw-text-emerald-900" />
          <p className="tw-text-emerald-900 tw-text-base tw-font-atkinson tw-m-0">
            The diagnostic is <span className="tw-font-bold">assigned and ready </span>for your class
          </p>
        </span>
        <Button
          label="Here’s what you need to prepare"
          className="tw-mt-10 tw-gap-x-2 tw-flex tw-flex-row-reverse"
          icon={<ArrowRight size={16} />}
          iconPos="right"
          onClick={() => navigate('/prep-diagnostics')}
        />
      </div>
    </div>
  );
};

export default TeacherDashboardDiagnosticWidgetEmpty;
